import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {loginControllerState} from "../../../utils/types";


const initialState: loginControllerState = {
    messageVisible: false
}

export const loginControllerSlice = createSlice({
    name: 'loginController',
    initialState,
    reducers: {
        setMessageVisible: (state, action:PayloadAction<boolean>) => {
            state.messageVisible = action.payload;
        }
    },
});

export const {
    setMessageVisible
} = loginControllerSlice.actions;

export default loginControllerSlice.reducer;